/**
 * The lesson facts are short on purpose for the tests. People should hear
 * them as a colleague explaining the step, and not the same sentence twice.
 */

const SPOKEN: Record<string, [string, string]> = {
  "20 GB for the whole school. Bin, then confirm Remove file.": [
    "The whole school shares 20 GB, not each file. To take one down, press the bin, then confirm Remove file.",
    "Storage is 20 GB for everyone together. Deleting asks you to confirm, so you don't lose a form by accident.",
  ],
  "A Circle is a group you can send to, or Everyone.": [
    "A Circle is a group, like Grade 2 or the choir. You can send to that Circle, or to Everyone.",
    "Think of a Circle as who should hear it. One group, or Everyone in the organization.",
  ],
  "A Draft is unsent. A Template is reused. Opening a Template sends nothing.": [
    "A Draft is the notice you haven't sent yet. A Template is the reusable one, and opening a Template sends nothing until you press Publish.",
    "Drafts are unfinished. Templates are the ones you reuse. Opening a Template does not send it to families.",
  ],
  "A Draft is unsent. A Template is reused. Opening it sends nothing.": [
    "A Draft is unsent. A Template is the reusable starting point, and opening it sends nothing.",
    "Keep a Draft when you're not ready. Use a Template when you'll send the same kind of notice again. Opening it sends nothing.",
  ],
  "A Notice is what you send. A Circle is a group. A User gets Notices in the app. A Team member uses this dashboard.": [
    "A Notice is what you send. A Circle is a group of people. A User reads it in the app. A Team member is someone on this dashboard with you.",
    "Four words you'll keep seeing: a Notice goes out, a Circle is who gets it, a User is in the app, and a Team member works here on the dashboard.",
  ],
  "A short hello.": [
    "Hi. I'll keep this short. Tell me what you're trying to do and I'll walk you through the page.",
    "Hello. I'll keep it short. Ask the step the way you'd ask a colleague, and I'll point at the button.",
  ],
  "ADD EVENT, or click a date. View notice opens it.": [
    "On the Calendar, press ADD EVENT, or click a date to start that day. If it's already on the month, View notice opens it.",
    "You don't have to leave the Calendar. ADD EVENT starts a new one, a click on the date starts that day, and View notice opens one that's already there.",
  ],
  "ADD MEMBER, name, phone, role, circles, Send invite.": [
    "On Team, press ADD MEMBER. Put in their name and phone, pick a role, choose their circles, then Send invite.",
    "Adding a teacher is ADD MEMBER: name, phone, role, which circles they can send to, then Send invite.",
  ],
  "Add signature. Handwriting font, not an upload. Pencil to change it. Old Awards keep it.": [
    "Add signature uses a handwriting font. You don't upload a picture of it. The pencil changes it later, and old Awards keep the signature they already have.",
    "It's not a scanned signature. Add signature, pick the handwriting, and use the pencil if you need to change it. Awards you've already sent keep the old one.",
  ],
  "Admins and Owners press Create template. Creators can use them.": [
    "Admins and Owners press Create template when you want to save one. Creators can use a template, they just can't make a new one.",
    "If you can press Create template, you're an Admin or an Owner. A Creator can fill one in and publish it, but not save a new template.",
  ],
  "Browse a grade, then Math. Print or Send.": [
    "In the Library, Browse a grade, then open Math. From there you can Print the worksheet or Send it to a Circle.",
    "Worksheets live in the Library. Browse the grade, choose Math, then Print for yourself or Send it to families.",
  ],
  "CREATE CIRCLE, then Create Sub-Circle.": [
    "Go to Circles and press CREATE CIRCLE. After the name and description, press Create Sub-Circle.",
    "The button is CREATE CIRCLE. Fill in the name, then Create Sub-Circle. That's the new group.",
  ],
  "Calendar is in the sidebar.": [
    "Calendar is in the sidebar, with the month of events and the notices that are waiting to go out.",
    "Open Calendar from the sidebar. That's the month view.",
  ],
  "Check it was sent, not a draft, and that they're in the Circle.": [
    "If a parent can't see it, check it was sent and not a draft, and that they're in the Circle you sent it to.",
    "Three things to check: it really went out, it isn't still a draft, and they're in that Circle.",
  ],
  "Claims card. One item per line. Claimed by under Poll Results.": [
    "Use the Claims card. Put one item per line. After people take them, Claimed by shows the name under Poll Results.",
    "A sign-up list is the Claims card, one item per line. You'll see who took what under Claimed by.",
  ],
  "Close the wizard with the cross before you publish, and press Save Draft. Drafts are under Pick up where you left off.": [
    "If you're not ready, close the wizard with the cross before you publish, and press Save Draft. You'll find it under Pick up where you left off.",
    "Nothing is sent if you Save Draft before you publish. Close with the cross, and come back to Pick up where you left off.",
  ],
  "Close with the cross, Save Draft, Pick up where you left off.": [
    "Close with the cross, choose Save Draft, and later open Pick up where you left off. Families don't see a draft.",
    "You can stop halfway. Close with the cross, Save Draft, and it waits under Pick up where you left off.",
  ],
  "Configurable values are the parts that change, then you Publish.": [
    "Configurable values are the bits that change each time, like the date and the price. Fill those in, then you Publish.",
    "The template leaves blanks. Those Configurable values are yours to fill, and you still press Publish yourself.",
  ],
  "Create a notice, title, message, who it's for, Publish.": [
    "Press Create a notice, write the title and the message, choose who it's for, then Publish. Nothing goes out before that.",
    "The path is Create a notice, then the title, then the message, then who it's for. You press Publish when it looks right.",
  ],
  "Create an event. Date, time, and place on Details.": [
    "Press Create an event. On Details, put the date, the time, and the place.",
    "An event needs a date, a time, and a place. Those fields are on Details after you press Create an event.",
  ],
  "Create is under Home.": [
    "Create sits under Home in the sidebar. That's where you start a notice, an event, an image, or a poll.",
    "Look just under Home. Create is the page with the cards for what you want to send.",
  ],
  "Create is under Home. That is where you start a new Notice.": [
    "Yes. Create is under Home, and that is where you start a new Notice.",
    "You can start from Home, and the full set of cards is on Create, just under Home.",
  ],
  "Creator sends. Owner looks after Circles and Team. Admin can do Users too.": [
    "A Creator sends notices. An Owner looks after Circles and the Team. An Admin can do Users as well.",
    "Most teachers only need Creator. Owner looks after the groups and the Team. Admin is the one who can invite Users too.",
  ],
  "Daily, Weekly, Every 2 weeks, or Monthly, until an End date.": [
    "It can repeat Daily, Weekly, Every 2 weeks, or Monthly. Give it an End date, and a weekly one needs that date at least a week later.",
    "Pick Daily, Weekly, Every 2 weeks, or Monthly, and set the End date so it knows when to stop.",
  ],
  "Duplicate it. You can't edit the sent one.": [
    "You can't edit the sent one. Duplicate it, fix the copy, and publish that.",
    "The one families already have stays as it was. Duplicate it if you need a corrected copy.",
  ],
  "Edit, Publish now, or Cancel schedule.": [
    "While it's waiting, you can Edit it, press Publish now, or Cancel schedule.",
    "On the Scheduled list you still have Edit, Publish now, or Cancel schedule. It hasn't gone to the app yet.",
  ],
  "Events on their date, Scheduled Notices on the day they go out, Upcoming Activity on the right.": [
    "The month shows Events on their date, and Scheduled Notices on the day they go out. Upcoming Activity is the list on the right.",
    "Calendar is a month at a time: events on the day they happen, scheduled notices on the day they publish, and Upcoming Activity down the right.",
  ],
  "Forgot PIN tells them to contact an administrator. Don't make another account.": [
    "Forgot PIN tells them to contact an administrator. Don't make another account for them.",
    "A forgotten PIN is reset by an administrator. A second account will only confuse things.",
  ],
  "Getting set up, Sending, Going further.": [
    "The course is three parts: Getting set up, then Sending, then Going further.",
    "Noticeboard Fundamentals starts with Getting set up, then Sending, then Going further.",
  ],
  "Help Center videos for a Notice, an Event, a Circle, and adding Users.": [
    "Help Center has short videos for a Notice, an Event, a Circle, and adding Users, if you'd rather watch than read.",
    "If the course feels long, Help Center videos cover a Notice, an Event, a Circle, and adding Users.",
  ],
  "Home shows what's happening.": [
    "Home shows what's happening, and it's also a quick place to start a Notice.",
    "Home is the snapshot at the top of the sidebar. It shows what's happening, and you can start a notice from there.",
  ],
  "Internal team only. Parents don't see it.": [
    "Choose Internal team only. Parents don't see that event. It's just for the staff.",
    "For a staff meeting, pick Internal team only. It stays off the parent app.",
  ],
  "It goes to the app and sits under Sent.": [
    "After you publish, it goes to the app and sits under Sent.",
    "Publish sends it straight to the app. You'll find the copy under Sent.",
  ],
  "Library is ready-made. Drive is your files.": [
    "Library is the ready-made worksheets. Drive is your own files, the ones your school uploaded.",
    "Use the Library for the worksheets we provide. Use Drive for your files.",
  ],
  "Mark as urgent. Email and push. Keep it for a closure.": [
    "Mark as urgent when it's a closure or something they must see. They get an email and a push. Save it for those days.",
    "Urgent means email and push, not just a notice in the app. Keep it for a closure, not the weekly newsletter.",
  ],
  "New Award, ID prefix, Awardees are the child, Users are the parents, Send to all.": [
    "Press New Award, add an ID prefix like MATH, then the Awardees. The Awardees are the children, and the Users you pick are the parents. Send to all when the list is ready.",
    "An Award starts with New Award and an ID prefix. Add the children as Awardees and their parents as Users. Nothing reaches them until Send to all.",
  ],
  "Nothing goes out until they press Publish.": [
    "I can line it up, but nothing goes out until you press Publish.",
    "You still press Publish. Nothing goes out before that, even if it looks ready.",
  ],
  "Noticeboard Fundamentals in Help Center.": [
    "The course is Noticeboard Fundamentals, in Help Center, lesson by lesson.",
    "If you want the whole path, open Noticeboard Fundamentals in Help Center. This chat is separate from the course.",
  ],
  "Notices lists sent, scheduled and drafts. Calendar shows Events.": [
    "Notices is the list of sent, scheduled, and drafts. Calendar shows Events on their dates.",
    "Already sent, still scheduled, or saved as a draft: that's the Notices page. The month of events is Calendar.",
  ],
  "Off means invite only. On means anyone in the Organization can join from the app.": [
    "Public Circle off means invite only. Turn it on and anyone in the Organization can join from the app.",
    "Leave Public off if you want to choose who joins. On means anyone in the Organization can join themselves from the app.",
  ],
  "On Review, Everyone or a Circle. Only Admins send to Everyone.": [
    "On Review you choose Everyone or a Circle. Only Admins can send to Everyone. A Creator sends to their Circles.",
    "The last step is Review. Pick a Circle, or Everyone if you're an Admin. Creators don't get Everyone.",
  ],
  "On Sent, Send reminder. The title starts with Reminder -. Same people. Check VIEWS first.": [
    "On the Sent notice, press Send reminder. The new title starts with Reminder -. It goes to the same people. Have a look at VIEWS first, so you only nudge people who haven't seen it.",
    "Send reminder is on the Sent list. Check VIEWS, then send. The title gets Reminder - in front, and the audience stays the same.",
  ],
  "On the Calendar, click a date to add an Event, or click one already on the month and press View notice.": [
    "On the Calendar, click a date to add an Event that day. If it's already on the month, click it and press View notice.",
    "You can start from the Calendar. Click an empty date for a new Event, or open one that's already there with View notice.",
  ],
  "One User can be in more than one Circle.": [
    "Yes. One User can be in more than one Circle. You don't need a second login for the choir and Grade 2.",
    "The same parent can sit in both Circles. One User, two groups.",
  ],
  "One question, the options, Publish. It can't be scheduled.": [
    "A poll is one question, then the options, then Publish. It can't be scheduled. It goes out straight away.",
    "Type the question and the options, then Publish. A poll can't wait until Monday. It can't be scheduled.",
  ],
  "One tap in the app. Poll Results and Who Voted. Not Responded, then the paper plane.": [
    "Parents vote with one tap in the app. You see Poll Results and Who Voted. Not Responded lists the rest, and the paper plane nudges one person.",
    "Voting is one tap in the app. Open Poll Results for the totals and Who Voted. For anyone quiet, Not Responded, then the paper plane.",
  ],
  "Open the REQUESTS tab on Users. Press Add user beside a request, or the cross to decline.": [
    "Open the REQUESTS tab on Users. Add user accepts them into a Circle. The cross declines the request.",
    "Join requests sit on REQUESTS under Users. Press Add user to let them in, or the cross if it's a no.",
  ],
  "People without the app wait under PENDING INVITATIONS.": [
    "If they don't have the app yet, they wait under PENDING INVITATIONS until they sign up.",
    "An invite to someone without the app sits in PENDING INVITATIONS. Once they join, they leave that list.",
  ],
  "Photos, Library, Camera, Document or Video.": [
    "Press the + and choose Photos, Library, Camera, Document or Video. A video attaches the same way as a PDF.",
    "The attachment choices are Photos, Library, Camera, Document or Video. Pick the file and it goes on the notice.",
  ],
  "REQUESTS on Users. Add user, or the cross to decline.": [
    "REQUESTS is on the Users page. Add user accepts the request. The cross declines it.",
    "You'll find REQUESTS on Users. Add user to say yes, or the cross to say no.",
  ],
  "Remove for 30 minutes. After that, Duplicate.": [
    "For 30 minutes after you send it, Remove takes it down. After that, Duplicate a corrected copy. This morning is already too late for Remove.",
    "Remove only lasts 30 minutes. Once that passes, Duplicate the notice and publish the fixed one.",
  ],
  "Same answer is a Poll. One person per item is a Claim list.": [
    "If everyone can pick the same answer, send a Poll. If only one person should take each item, use a Claim list.",
    "If they can all pick the same answer, it's a Poll. Cupcakes, one parent each, is a Claim list.",
  ],
  "Say cancel to stop. Looks good opens Create. They press Publish.": [
    "Say cancel if you want me to stop. Looks good opens Create with it filled in, and you still press Publish.",
    "I won't send it for you. Cancel stops the draft of the conversation. Looks good opens Create, and Publish is still your button.",
  ],
  "Schedule for later, date and time, then Schedule on Review.": [
    "Don't leave it on Post now. Choose Schedule for later, set the date and time, then press Schedule on Review.",
    "You can send it tomorrow morning. Schedule for later, pick the date and time, and the button on Review says Schedule.",
  ],
  "Send to all. Download PNG or PDF. Resend one.": [
    "When the list is ready, press Send to all. You can Download a PNG or PDF, or Resend one certificate if a parent missed it.",
    "Parents get nothing until Send to all. After that you can Download PNG or PDF, or Resend a single one.",
  ],
  "Share the username and PIN privately, plus the dashboard address.": [
    "After Send invite you'll see a username and a PIN. Share them privately, with the dashboard address. They sign in on the website, not the app.",
    "Hand them the username and PIN privately, and the dashboard address. Don't put the PIN in a notice.",
  ],
  "The Reminder card on Settings, not Send reminder.": [
    "To nudge people before the event, use the Reminder card on Settings. That is not the Send reminder button on a sent notice.",
    "The day-before nudge is the Reminder card on the event's Settings. Send reminder is a different thing, for a notice that's already out.",
  ],
  "The Team writes on the dashboard. Families get Notices in the app.": [
    "Your Team writes on this dashboard. Families get the Notices in the app.",
    "You stay on the dashboard. Parents stay in the app. The Team writes here, and families read it there.",
  ],
  "The design. Publish it. Publishing locks it. Duplicate to change it.": [
    "A certificate template is the design. Publish it before you use it on an Award. Publishing locks it, so Duplicate the design if you need to change it.",
    "There are ready-made designs. Publish the one you want. Publishing locks it, and Duplicate is how you make a new version.",
  ],
  "The sidebar on the left takes you to every part of the dashboard. On a phone, the same pages are in the menu.": [
    "The sidebar on the left is how you move around the dashboard. On a phone, the same pages are in the menu.",
    "Everything you can open is in the sidebar on the left of the dashboard. On a phone, open the menu and the pages are there.",
  ],
  "The sidebar on the left. On a phone, the menu.": [
    "The list on the left is the sidebar. On a phone, it's the menu.",
    "Use the sidebar on the left. On a phone, the same pages are in the menu.",
  ],
  "The sparkle, or Command K / Control K. This chat, not the course.": [
    "I'm the sparkle next to your picture, or Command K on a Mac and Control K otherwise. This chat is not the course.",
    "Press the sparkle, or Command K / Control K, to open me again. The course is separate, in Help Center.",
  ],
  "The website is for the Team. The app is for families.": [
    "The website is for the Team. The app is for families. You don't need the app to send something.",
    "You work here on the website. Families use the app. Same notices, two sides.",
  ],
  "Turn on RSVPs. Who responded is on the Event. Families answer in the app.": [
    "Turn on RSVPs if you want to know who's coming. Who responded is on the Event, and families answer in the app. You can set a deadline for replies.",
    "RSVPs are a switch on the event. Families answer in the app, and you read Who responded on the Event.",
  ],
  "UPLOAD FOLDER, a clear name, share with a Circle. Don't leave everything in the root.": [
    "On Drive, press UPLOAD FOLDER, give it a clear name like Grade 2 Term 1, and share it with a Circle. Don't leave everything in the root.",
    "Make a folder with UPLOAD FOLDER and share it with the Circle that needs it. The root is just the main list. Don't leave everything there.",
  ],
  "Use Image when the picture is the Notice.": [
    "Use Image when the picture is the Notice, like a poster. The message underneath can be empty.",
    "If the flyer is the whole notice, use the Image card. Use Image when the picture is the Notice, not when you're only attaching a file.",
  ],
  "Users, ADD USER, email phone or username.": [
    "On Users, press ADD USER. You can invite them by email, phone, or username.",
    "Bringing a family onto the app starts at Users, then ADD USER. Email, phone, or username all work.",
  ],
  "VIEWS under Sent. Viewers lists names.": [
    "VIEWS under Sent is how many people have opened it. Viewers lists the names, so you can see who hasn't.",
    "The number is VIEWS, on the Sent notice. Open Viewers if you want the names.",
  ],
  "You can paste several email addresses at once.": [
    "Yes. You can paste several email addresses at once on Add user. You don't have to type the class list one by one.",
    "Paste the whole list. You can paste several email addresses at once.",
  ],
  "You're welcome.": [
    "You're welcome. What else are you trying to do?",
    "You're welcome. Ask the next step whenever you're ready.",
  ],
};

function pick(options: readonly string[], question: string, spin: number): string {
  let hash = 0;
  for (let i = 0; i < question.length; i += 1) hash = (hash * 33 + question.charCodeAt(i)) >>> 0;
  return options[(hash + spin) % options.length];
}

/** A lesson fact, said the way a person would say it. The fact's words stay in the sentence. */
export function speakLesson(question: string, fact: string, spin: number): string {
  const options = SPOKEN[fact];
  if (!options) return fact;
  return pick(options, question, spin);
}
